import React from 'react';

interface SheetButtonProps {
  text: string;
  onClick: () => void;
  isLoading?: boolean;
  className?: string;
  disabled?: boolean;
}

const SheetButton: React.FC<SheetButtonProps> = ({
  text,
  onClick,
  isLoading = false,
  className = '',
  disabled = false,
}) => {
  const baseStyles = `
    bg-[#1573FE] text-white h-[32px] rounded-lg hover:bg-[#1573FF] transition duration-200
    
  `;

  return (
    <button
      onClick={onClick}
    //   isLoading={isLoading}
      className={`${baseStyles} ${className}`}
      disabled={disabled}
    >{text}</button>
  );
};

export default SheetButton; 